import { render, staticRenderFns } from "./EditLevel.vue?vue&type=template&id=b09b1caa&scoped=true&lang=pug&"
import script from "./EditLevel.vue?vue&type=script&lang=js&"
export * from "./EditLevel.vue?vue&type=script&lang=js&"
import style0 from "./EditLevel.vue?vue&type=style&index=0&id=b09b1caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09b1caa",
  null
  
)

export default component.exports